// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BadgeNotification_fadeIn__YP8JS {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.4s linear;
}

.BadgeNotification_fadeOut__C3yYr {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.4s linear;
}
`, "",{"version":3,"sources":["webpack://./src/standaloneComponents/BadgeNotification.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,+BAA+B;AACnC","sourcesContent":[".fadeIn {\n    visibility: visible;\n    opacity: 1;\n    transition: opacity 0.4s linear;\n}\n\n.fadeOut {\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity 0.4s linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fadeIn": `BadgeNotification_fadeIn__YP8JS`,
	"fadeOut": `BadgeNotification_fadeOut__C3yYr`
};
export default ___CSS_LOADER_EXPORT___;
